import { IoPeopleCircleOutline } from 'react-icons/io5'

import { UserRegistry } from '../Components/UserRegistry'

import type { IPageConfig } from '@/Core/Contracts/Loaders/IPageConfig'

/**
 * «Активні співробітники» — корінь розділу «Співробітники» (`SPEC-005` §7.1).
 * Ключ збігається з ключем ресурсу: сторінка заміняє ядровий список, а
 * картки лишаються ядровими (`/users/{uuid}`).
 */
export const UserPage = () => <UserRegistry kind="active" />

export default UserPage

export const pageConfig: IPageConfig = {
    key: 'Setting.User',
    route: '/users',
    title: 'Співробітники',
    // Іконку пункту меню ядро бере зі сторінки, а не з ресурсу (`SPEC-014` Г15)
    icon: <IoPeopleCircleOutline />,
}
